import React from 'react'
import './Copyrights.css'

function Copyrights() {
  return (
    <div className="Copyrights">
      <p className="CopyrightsText">
        Copyright © 2026 HLZ Tech. All rights reserved.
        <br />
        Developed by : <a href="https://www.facebook.com/">Tiger Tsui</a>
      </p>
    </div>
  );
}

export default Copyrights;